import login from './login/login_en'
import forgotPassword from './forgotPassword/forgotPassword_en'
import changePassword from './changePassword/changePassword_en'
import home from './home/home_en'
import termsAndConditions from './termsAndConditions/termsAndConditions_en'
import updatePassword from './updatePassword/updatePassword_en';
import settlements from './settlements/settlements_en'
import authorizationTypes from './authorization/types/types_en';
import outpatientCare from './authorization/outpatient-care/outpatient-care_en';
import doctorFields from './authorization/outpatient-care/doctor-fields/doctor-fields_en';
import identityValidation from './authorization/outpatient-care/identity-validation/identity-validation_en';
import beneficiaryResults from './authorization/outpatient-care/beneficiary-results/beneficiary-results_en';
import createSettlement from './settlements/create-settlement/create-settlement_en'
import filters from './filters/filters_en'
import settlementDetail from './settlements/settlement-detail_en'

import addAuthorization from './addAuthorization/en'
import authorizationList from './authorizationList/en'
import authorizationDetail from './authorizationDetail/en'
import profile from './profile/profile_en'
import tfa from './tfa/tfa_en'


export default {
  globalErrorUnknown: 'We had a technical glitch! Please, try again or contact your technical support team.',
  loading: 'Loading',
  errorTitle: 'An error has occurred',
  defaultErrorDescription: 'Please contact the support team for more information.',
  badCredentials: '¡Bad credentials! Please, try again.',
  buttons: {
    close: 'Close',
    save: 'Save',
    delete: 'Delete'
  },
  errors: {
    inputValidations: {
      required: 'Required field',
      invalidFormat: 'Invalid format',
      maxLength: 'The field has exceed the {n} characters limit',
      minLength: '{n} characters minimum',
      invalidFile: "The file type is invalid",
      invalidFileSize: "The file exceeds the maximum allowed size",
      maxFiles: "The limit of files has been exceeded ({n})",
      fileRequired: "Attach a file is required",
      ClaimTypeRequired: "The type of request is required",
      authorizationTypeRequired: "The type of authorization is required",
      invalid: "The value is invalid",
      invalidDate: "The date is invalid.",
      beneficiaryRequired: 'The beneficiary is required.',
      invalidBirthday: 'The birthday is invalid.',
    }
  },
  drawer: {
    logout: 'Logout'
  },
  footer: {
    privacyLabel: 'Privacy'
  },
  locales: {
    es: 'Spanish',
    en: 'English'
  },
  identityDocumentTypes: {
      passport: 'Passport',
      nationalIdentityCard: 'National identity card',
      socialSecurityNumber: 'Social security number',
      taxIdentificationNumber: 'Tax identification number',
      electoralRegistryNumber: 'Electoral registry number'
  },
  genders: {
    male: 'Male',
    female: 'Female'
  },
  posology: {
      day: '{value} day | {value} days',
      unit: 'unit | units',
      medicalDeviceDescription: 'Use {0} ({1}) {2} for {3} ({4}) {5}',
      half: 'half',
      andConnector: 'and a',
      pointConnector: 'point',
      quarter: 'one quarter | {value} quarter',
  },
  emptyList: {
    desktop: 'No results found',
    mobile: {
      prefix: 'No results found',
      sufix: ''
    }
  },
  emptyListDescription: {
    prefix: 'Try search another term',
    middle: 'or',
    sufix: 'applied.'
  },
  chronicTreatmentLabel: 'Chronic treatment',
  login,
  forgotPassword,
  changePassword,
  home,
  termsAndConditions,
  updatePassword,
  settlements,
  authorizationTypes,
  outpatientCare,
  doctorFields,
  identityValidation,
  beneficiaryResults,
  filters,
  settlementDetail,
  createSettlement,
  addAuthorization,
  authorizationList,
  authorizationDetail,
  profile,
  tfa
}
